import { AttendanceModel } from "@gtpl/shared-models/hrms";
import { Injectable } from "@nestjs/common";
import { AttendanceEntity } from "../entities/attendance.entity";

@Injectable()
export class AttendanceAdapter {

    public convertDtoToEntity(employeeId: number, logDate: Date, employeeCode: string, employeeName: string, deviceCode: string, downloadDate: string, verifyMode: string, departmentId: number, day: number, month: number, year: number): AttendanceEntity {
        const attnEntity = new AttendanceEntity();
        attnEntity.employeeId = employeeId;
        attnEntity.logDate = logDate;
        attnEntity.employeeCode = employeeCode;
        attnEntity.employeeName = employeeName;
        attnEntity.deviceCode = deviceCode;
        attnEntity.downloadDate = downloadDate;
        attnEntity.verifyMode = verifyMode;
        attnEntity.departmentId = departmentId;
        attnEntity.day = day;
        attnEntity.month = month;
        attnEntity.year = year;

        return attnEntity;
    }

    public convertEntityToDto(attnEntity: AttendanceEntity): AttendanceModel {
        return new AttendanceModel(attnEntity.employeeId, attnEntity.employeeCode, attnEntity.employeeName, attnEntity.date, attnEntity.inTime, attnEntity.outTime, attnEntity.logDate, attnEntity.rfCode, attnEntity.deviceCode, attnEntity.downloadDate, attnEntity.presentStatus, attnEntity.shift, attnEntity.verifyMode, attnEntity.departmentId, attnEntity.departmentCode, attnEntity.designation, attnEntity.shiftGroup, attnEntity.unitId);
    }

    getAttendanceEntity(employeeId: number, date: string, logDate: Date, employeeCode: string, employeeName: string, deviceCode: string, downloadDate: string, presentStatus: string, inTime: Date, outTime: Date, verifyMode: string, shift: string, departmentId: number, shiftGroup: string, designation: string, unitId: number, day: number, month: number, year: number): AttendanceEntity {
        const attnEntity = new AttendanceEntity();
        attnEntity.employeeId = employeeId;
        attnEntity.date = date;
        attnEntity.logDate = logDate;
        attnEntity.deviceCode = deviceCode;
        attnEntity.employeeCode = employeeCode;
        attnEntity.employeeName = employeeName;
        attnEntity.downloadDate = downloadDate;
        attnEntity.presentStatus = presentStatus;
        attnEntity.inTime = inTime;
        attnEntity.outTime = outTime;
        attnEntity.verifyMode = verifyMode;
        attnEntity.departmentId = departmentId;
        attnEntity.shiftGroup = shiftGroup;
        attnEntity.designation = designation;
        attnEntity.unitId = unitId;
        attnEntity.shift = shift;
        attnEntity.day = day;
        attnEntity.month = month;
        attnEntity.year = year;
        return attnEntity;
    }
}